import React, { Fragment } from "react";
import { Breadcrumbs, Paper, Typography, withStyles } from '@material-ui/core';
import {Button, Col, Row} from 'react-bootstrap';
import moment from 'moment';
import autoBind from 'react-autobind';
import { Query } from "react-apollo";
import { participanteSessoesAndamentoListQuery } from '../../graphql/Sessao';
import { Link } from "react-router-dom";
import Environment from "../../environment/environment";

const styles = theme => ({
    sessionsEnterButtonContainer: {
        display: 'block',
        backgroundColor: 'yellow',
    },
    buttonSession: {
        width: '100%',
        color: "#fff",
        fontFamily: "-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji",
        fontWeight: 600,
        backgroundColor: "#28a745",
        backgroundImage: "linear-gradient(-180deg,#34d058,#28a745 95%)",
        borderRadius: '.25em',
        marginBottom: '10px',
        paddingTop: '35px',
        paddingBottom: '35px',
        fontSize: '17px',
        borderTop: 0,
        borderLeft: 0,
        borderColor: "rgba(27,31,35,.2)",
        '&:hover': {
            borderTop: 1,
            borderLeft: 1,
            borderRight: 0,
            borderBottom: 0,
            color: "#415e01"
        }
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    root: {
        padding: theme.spacing(3, 2),
        minHeight: 470
    },
    noSessionsFound: {
        fontSize: '14px',
        color: '#000'
    }
});

class PartEmAndamento extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            verArquivados: false,
            definicaoSelecionada: null,
            id: null
        }
        autoBind(this);
    }

    doRefetch() {
        if (!this._queryRefetch)
            return;

        this.props.client.clearStore().then (
            () => this._queryRefetch(this._queryVariables ? { variables: this._queryVariables } : {})
        );
    }

    render() {
        const { classes } = this.props;
        return (
            <Paper className={classes.root}>
                {this.renderBreadCrumb()}
                <Fragment>
                    {this.renderGridPrincipal()}
                </Fragment>
            </Paper >
        );
    }

    renderGridPrincipal() {
        const { classes } = this.props;
        return (
            <div>
                <Query query={participanteSessoesAndamentoListQuery} pollInterval={5000} fetchPolicy='network-only'>
                    {({ data, loading, error, refetch }) => {
                        if (loading) return 'Carregando ...';
                        if (error) return `Error! ${error.message}`;
                        this._queryRefetch = refetch;

                        const { participanteSessoesAndamentoList } = data;
                        const renderedSessionEnterButtons = participanteSessoesAndamentoList.map( el => {
                            const linkTo = '/'+el.slug;

                            const dataInicio = Environment.momentToLocalDateAndTimeString(el.inicio);
                            const dataFim = Environment.momentToLocalDateAndTimeString(el.fim);

                            let periodo = dataInicio + " até " + dataFim;

                            if(dataInicio.split(" ")[0] == dataFim.split(" ")[0]) {
                                periodo = dataInicio + " às " + dataFim.split(" ")[1];
                            }


                            return (
                                <Col md={4} key={el.id}>
                                    <Link to={linkTo}>
                                        <Button className={classes.buttonSession}>
                                            {el.nome}<br/>
                                            <small>{periodo}</small>
                                        </Button>
                                    </Link>
                                </Col>
                            );
                        });

                        const noSessionsFound = () => {
                            return (
                                <Col md={12}>
                                    <p className={classes.noSessionsFound}>Nenhuma sessão em andamento neste momento</p>
                                </Col>
                            );
                        }

                        return (
                            <div>
                                <Row>
                                    { participanteSessoesAndamentoList.length > 0 ? renderedSessionEnterButtons : noSessionsFound() }
                                </Row>
                            </div>
                        );
                    }}
                </Query>
            </div>
        );
    }

    renderBreadCrumb() {
        return <Breadcrumbs aria-label="Breadcrumb" className="bradcrumbs">
                   <Typography >Participar</Typography>
                   <div>Sessões em andamento</div>
               </Breadcrumbs>;
    }

}

export default (withStyles(styles)(PartEmAndamento));